export const GET_SPONSOR_ADVISOR_UPDATES_SUCCESS =
    'GET_SPONSOR_ADVISOR_UPDATES_SUCCESS';
export const SET_SPONSOR_ADVISOR_UPDATES_LOADING =
    'SET_SPONSOR_ADVISOR_UPDATES_LOADING';
